import React from "react";

/**
 * PlayButton Component - Handles audio playback controls
 * 
 * @param {boolean} isPlaying - Whether audio is currently playing
 * @param {Function} onPlay - Callback to start/stop playback
 */
const PlayButton = ({ isPlaying, onPlay }) => {
  return (
    <button 
      className={`play-button-corner ${isPlaying ? 'playing' : ''}`}
      onClick={onPlay}
      title={isPlaying ? 'Stop playback' : 'Play scale'}
    >
      {isPlaying ? '⏸' : '▶'}
    </button>
  );
};

export default PlayButton;